<template>
  <div class="tkdetails full-height linear-main3">
    <ld-header
      @click-left="$router.push({path:'/allOrder?findType=0'})"
      :transparent="true"
      :white="true"
    >
      <span class="font12">{{ $t('F001','订单号') }}：{{ details.orderNo }} &nbsp;{{ details.tripType|tripType }}</span>
    </ld-header>

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <travel-tips
            v-if="details.orderRangeBeanList[0]"
            :city-id="(details.orderRangeBeanList[0]?details.orderRangeBeanList[0].arriveCityId:'')"
          />

          <div class="head white ">
            <div class="font22 font-md fontTitle">
              <span>{{ details.orderStatusRemark }}</span>
              <van-tag type="warning" v-if="'' != details.productColor && 3 == details.productType"
                       :color="details.productColor" style="margin-right: 70px;">
                {{ details.productTag || "" }}
              </van-tag>
              <van-tag type="warning" v-else>
                {{ details.productTag || "" }}
              </van-tag>
              <ld-email-popup
                v-if="details.id && !isYlslh5"
                :id="details.id"
                :djlx="details.orderType"
                :order-no="details.orderNo"
              />
            </div>
            <div>{{ $t('F002','预订时间') }}：{{ details.bookDate }}</div>
            <div>{{ $t('F003','预订人') }}：{{ details.bookerName }}</div>
          </div>
          <div
            class="planeBox"
            v-for="(item) in details.orderRangeBeanList"
            :key="item.id"
          >
            <div class="xc" v-if="0">
              <span>第{{ lcname }}程</span>
            </div>
            <voyage
              :flight="item"
              :showCar="showCar"
              :ccsqdId="details.ccsqdId"
              :show-rule="true"
            >
              <van-tag
                type="danger"
                plain
                v-if="details.isyw == 1"
                slot="tag-less"
              >
                {{ $t('F620','延误/取消') }}
              </van-tag>
            </voyage>
          </div>
          <div class="planeBox">
            <traver
              :traveler-list="details.orderPsgBeanList"
              :disabled="true"
              :add-button="false"
              :title="$t('C001','乘机人')"
            />
          </div>
          <!-- 保险 -->
          <insurance
            class="m-b-5"
            v-if="details.id"
            :cxrlength="details.orderPsgBeanList.length"
            :order-id="details.id"
            :cplx="cplx"
            element=".tkdetails"
            :check-bx-list.sync="checkBxList"
          />
          <!-- 退 -->
          <div
            class="m-b-5"
            v-for="r in refund"
            :key="r.refundId"
            @click="$router.push({path:'/tk/tkRefundDetail?orderId='+r.refundId})"
          >
            <div
              v-for="g in r.refundRangeList"
              :key="g.rangeId"
            >
              <voyage :flight="g">
                <!-- :show-rule="flightItem.newChange?true:false" -->
                <van-tag
                  type="danger"
                  slot="tag"
                >
                  <span>{{ $t('H117','退') }}</span>
                </van-tag>
                <span slot="right">{{ r.refundStatusRemark }}</span>
              </voyage>
            </div>
          </div>
          <!-- 改 -->
          <div
            class="m-b-5"
            v-for="(el,dtindex2) in change"
            :key="dtindex2"
            @click="$router.push({path:'/tk/tkChangeDetail?orderId='+el.changeId})"
          >
            <div
              v-for="(p,dtindex3) in el.rangeList"
              :key="dtindex3"
            >
              <voyage :flight="p" :showCar="true" :ccsqdId="details.ccsqdId">
                <!-- :show-rule="flightItem.newChange?true:false" -->
                <van-tag
                  type="warning"
                  slot="tag"
                >
                  <span>改</span>
                </van-tag>
                <span slot="right">{{ el.changeAmount }}</span>
              </voyage>
            </div>
          </div>

          <!-- 差旅信息 -->
          <div v-if="details.tripType==1">
            <div class="planeBox">
              <travel-info
                ref="travelinfo"
                :travel-data="details"
                :details="true"
              />
            </div>
            <div
              class="planeBox"
              v-if="details.vipStatus != 4"
            >
              <!-- 审批规则 -->
              <approval
                :vip-status="details.vipStatus"
                :order-id="details.id"
                :spgz-id="details.appId"
                :order-type="details.orderType"
                :ssbz="details.ccsqdRemark"
                :isssbz="details.isShowApproval!='1'"
                element=".tkdetails"
              />
            </div>
            <ld-uploader
              class="mt5 round-sm overflow"
              v-if="details.id"
              :order-id="details.id"
              :glywlx="details.orderType"
              :cjlx="2"
              :order-status="details.orderStatus"
            />
          </div>
          <div
            class="qrCodbox"
            v-show="airlineData.qrCodeUrl && showqrCodbox"
          >
            <img :src="airlineData.qrCodeUrl">
            <p>{{ airlineData.title }}</p>
          </div>
        </div>
      </mescroll-vue>
    </div>

    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
      class="bg-white shadow"
    >
      <van-row
        class="full-width pad-lr-10"
        type="flex"
        align="center"
        gutter="8"
      >
        <van-col span="6">
          <div class="font10 gray">
            {{ $t('E017','共') }}
            {{ details.orderPsgBeanList.length }}
            {{ $t('E113','人') }}
          </div>
          <span class="font12 money-color">&yen; </span>
          <span class="font22 money-color"> {{ details.totalPrice+(details.bxPrice||0) }}</span>
          <span
            class="font12 text-center"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <!-- <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            /> -->
          </span>
        </van-col>
        <van-col span="18">
          <van-row
            type="flex"
            justify="end"
            gutter="8"
          >
            <van-col
              span="8"
              v-if="details.isShowCancel==1"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('cancel')"
              >
                {{ $t('B008','取消') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="details.isShowCancelApproval==1"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('revertApproval')"
              >
                {{ $t('B065','撤回') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="details.isShowEndorse==1 && details.international==1"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('change')"
              >
                {{ $t('B034','改签') }}
              </ld-button>
            </van-col>

            <van-col
              span="8"
              v-if="details.isShowRefund==1 && details.international==1"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('refund')"
              >
                {{ $t('B035','退票') }}
              </ld-button>
            </van-col>
            <van-col
              span="8"
              v-if="details.isShowApproval==2"
            >
              <ld-button
                main
                size="md"
                @click.native="btnClick('sendApproval')"
              >
                {{ $t('Submit','再送审') }}
              </ld-button>
            </van-col>
            <van-col
              span="8"
              v-if="details.isShowApproval==1"
            >
              <ld-button
                main
                size="md"
                @click.native="btnClick('sendApproval')"
              >
                {{ $t('B028','送审') }}
              </ld-button>
            </van-col>
            <van-col
              span="8"
              v-if="details.isShowPay==1"
            >
              <ld-button
                main
                size="md"
                @click.native="btnClick('pay')"
              >
                {{ $t('B014','支付') }}
              </ld-button>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </ld-tabbar>


    <!--支付  -->
    <!-- <ld-pay
      ref="pay"
      @selected="pay"
      :order-type="details.orderType"
      :order-id="details.id"
    /> -->
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
import voyage from 'Components/tk/voyage/voyage.vue'
import traver from 'Components/tk/traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import insurance from 'Components/insurance'
import approval from 'Components/approval/approval'
import MescrollVue from 'mescroll.js/mescroll.vue'
import {Cell,Tag,Popup} from 'vant'
import { changeData } from '../tkChange/utils'
import Business from '@/business/utils/business'
import travelTips from 'Components/travelTips'
import ldUploader from 'Components/ldUploader'
import ldEmailPopup from 'Components/LdEmailPopup'
import defaultMixin from "@/business/mixins/default";


export default {
  name:'TkDetail',
  mixins:[defaultMixin],
  components: {
    ldButton,
    voyage,
    traver,
    ldTabbar,
    travelInfo,
    MescrollVue,
    insurance,
    approval,
    [Cell.name]:Cell,
    [Tag.name]:Tag,
    [Popup.name]:Popup,
    travelTips,
    ldUploader,
    ldEmailPopup
  },
  data() {
    return {
      lcname: '',
      down: {use: false},
      details: {
        orderPsgBeanList: [],
        orderRangeBeanList: []
      },
      order: {},
      checkBxList: [],
      refund: [],
      change: [],
      airlineData: {}, //航司信息
      showCar: true,
    }
  },
  props:{
    id:{
      type:String,
      default:''
    },
    isLdentifying:{
      type:String,
      default:''
    },
    showqrCodbox:{
      type:Boolean,
      default:true
    }
  },
  computed:{
    orderId(){
      return this.$route.query.orderId||this.id
    },
    priceList(){
      let adult= {name:'成人',price:'',amount:0,unit:'人'},
        child={name:'儿童',price:'',amount:0,unit:'人'},
        baby={name:'婴儿',price:'',amount:0,unit:'人'},
        arr=[],first={},
        cxr=this.details.orderPsgBeanList
      if(cxr.length>0){
        cxr.forEach((item) =>{
          if(item.psgType==1){
            adult.amount+=1
            adult.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
            first=item
          }else if(item.psgType==2){
            child.amount+=1
            child.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
          }else if(item.psgType==3){
            baby.amount+=1
            baby.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
          }
        })
        if(!first.salePrice){
          first=cxr[0]
        }
        adult.show=adult.amount>0
        child.show=child.amount>0
        baby.show=baby.amount>0
        arr=[
          adult,child,baby,
          {name:'机票',price:first.salePrice,amount:cxr.length,unit:'/人'},
          {name:'机建',price:first.airportFee,amount:cxr.length,unit:'/人'},
          {name:'燃油税',price:first.tax,amount:cxr.length,unit:'/人'},
          {name:'保险',price:this.details.bxPrice?this.details.bxPrice/cxr.length:0,amount:`/${this.checkBxList.length}份`,unit:''},
          { name: '直减', price:'-'+first.khjl, amount: cxr.length, unit: '/'+this.$t('E113','人') ,show:first.khjl>0}
        ]
        if (!this.isYlslh5){
          arr.push({name:'服务费',price:first.serviceFee,amount:cxr.length,unit:'/人'})
        }
      }
      return arr
    },
    cplx(){
      return this.details.international==0?'10902':'10901'
    }
  },
  mounted() {
  },
  updated() {
  },
  async created(){
    if(this.orderId){
      this.getDetail()
      this.getRefund()
      this.getChange()
    }else if(this.$route.query.order){
      this.order=this.$route.query.order
    }
  },
  methods: {
    async asyncFunc() {
      let result = await new Promise(() => {
        setTimeout(() => {
          var  st =  JSON.parse(sessionStorage.getItem('objp'));
          if(st[0].orderNo == this.details.orderNo ? true : false){
            this.lcname = '1'
          }else if(st[1].orderNo == this.details.orderNo ? true : false){
            this.lcname = '2'
          }
        }, 1000)
      })
    },
    btnClick(name){
      let self=this
      let obj={
        cancel(){//取消
          self.$dialog.confirm({
            message:'是否取消订单'
          }).then(() => {
            self.$api['tkOrder/cancelTkOrder']({
              orderId:self.orderId
            }).then(() => {
              self.$toast('订单已取消')
              self.getDetail()
            })
          })
        },
        sendApproval () {//送审
          self.details.orderType = $dict.ORDER_TYPE.tk.normal
          Business.ApprovalSend(self.details, () => {
            self.getDetail()
          })
        },
        async revertApproval () { // 撤回
          await Business.ApprovalRevert(self.details)
          self.getDetail()
        },
        refund(){//退票
          self.$router.push({path:'/tk/tkRefundApply',query:{orderId:self.details.id}})
        },
        change(){//改签
          self.$router.push({path:'/tk/tkChangeApply',query:{orderId:self.details.id}})
        },
        pay(){//支付
          // self.toggle('pay')
          self.$router.push({path:'/pay/payment',query:{orderType:self.details.orderType,orderId:self.details.id}})
        }
      }
      name&&obj[name]&&obj[name]()
    },
    pay(){
      this.getDetail()
    },
    getDetail(){
      this.$api['tkOrder/orderDetail']({
        id:this.orderId
      }).then(res => {
        let cache=res.data||{}
        if(this.isLdentifying){
          let index =  cache.orderStatusRemark.indexOf('|')
          cache.orderStatusRemark  = cache.orderStatusRemark.substr(0, index+1)+'确认中'
        }
        this.details=cache
        this.getFindByAirline()
      }).catch(res =>{
        this.$toast(res.errMsg)
      })
    },
    getFindByAirline(){
      this.$api['tkOrder/findByAirline']({
        airline:this.details.airline
      }).then(res => {
        this.airlineData = res.data || {}
      }).catch(res =>{
        this.$toast(res.errMsg)
      })
    },
    getRefund(){
      this.$api['tkOrder/moreRefundInfo']({
        orderId:this.orderId
      }).then(res => {
        this.refund=res.data||[]
      }).catch(res =>{
        this.$toast(res.errMsg)
      })
    },
    getChange() {
      this.$api['tkOrder/findChangeOrderByOrderId']({
        orderId: this.orderId
      }).then(res => {
        let range = res.data || []
        if (range.length > 0) {
          range.forEach(el => {
            let rangeList = changeData(el.rangeList)
            var arr = []
            rangeList.forEach(item => {
              if (item.newChange) {
                arr.push(item)
              }
            })
            el.rangeList = arr
          })
          this.change = range
          this.showCar = false;
        }
      }).catch(res => {
        this.$toast(res.errMsg)
      })
    },
    toggle(ref){
      this.$refs[ref].toggle()
    },
  },
  filters:{
    tripType(val){
      return val==1?'公':'私'
    }
  }
}
</script>

<style lang="less" scoped>
@import "~Assets/styles/business.less";
.fontTitle{
  display: flex;
  justify-content:space-between;
  align-items:center;
  .dowPdf{
    font-size: 16px;
  }
}
.tkdetails{

    .box{
        padding: 0 8px 50px;
        .head{
            padding: 0.3rem 0.2rem 0.4rem;
        }
    }
    .planeBox{
        padding-bottom: 5px;
    }
}
.pad-5{
    padding: 5px;
}
.pad-lr-10{
    padding: 0 10px;
}
.m-b-5{
    margin-bottom: 5px;
}
.wrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
}
 .qrCodbox{
      margin-top: 5px;
      padding: 10px;
      width: 100%;
      height: auto;
      background: white;
      text-align:center;
      img{
        width: 130px;
        height: 130px;
        margin: 20px 0;
        background: black;
      }
      p{
        font-weight: 900;
        font-size: 18px;
      }
    }
 .xc{
   width: 44px;
   height: 20px;
   line-height: 20px;
   background-image: linear-gradient(-90deg, #45bf9b 0%, #52dcb3 100%), linear-gradient(#eef2f7, #eef2f7);
   background-blend-mode: normal, normal;
   box-shadow: 0px 2px 2px 0px rgba(51, 164, 131, 0.3);
   border-radius: 5px;
   text-align: center;

 }
</style>
